import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./Slider.module.css";
import { useEffect, useState } from "react";
import { default as HomeSlider } from "infinite-react-carousel";
import { Link } from "react-router-dom";
const Slider = ({ items, attachedLinks }) => {
  const [isMobile, setIsMobile] = useState(null);
  const [sliderItems, setSliderItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [sliderCount, setSlideCount] = useState(0);
  useEffect(() => {
    if (items.length > 0) {
      const activeSliders = items.filter(
        (item) => item.attachment_files.length > 0
      );
      setSlideCount(items.length);
      setSliderItems(activeSliders);
    }
    setIsMobile(window.mobileCheck());
  }, [items]);
  return (
    <div className={styles.sliderWrapper}>
      {isMobile === false ? (
        <div className={styles.innerSliderWrapper}>
          {sliderItems && sliderItems.length > 0 ? (
            <div
              id="fullWidthCarousel"
              className="carousel slide carousel-fade"
              data-interval="false"
            >
              <div className={styles.carouselWrapper}>
                {sliderItems.map((item, index) => (
                  <SliderElem
                    activeIndex={activeIndex}
                    item={item}
                    key={`${index}-slider-main-elem`}
                  />
                ))}
              </div>
              <div
                className={
                  attachedLinks
                    ? `${styles.arrows} ${styles.arrowWithLinks}`
                    : styles.arrows
                }
              >
                <a
                  onClick={() =>
                    activeIndex === 0
                      ? setActiveIndex(sliderItems.length - 1)
                      : setActiveIndex(activeIndex - 1)
                  }
                  className="left carousel-control"
                  data-slide="prev"
                >
                  <i className="fa fa-chevron-left"></i>
                </a>
                <ol className="carousel-indicators">
                  {items.map(
                    (item, index) =>
                      Array.isArray(item.attachment_files) &&
                      item.attachment_files.length > 0 && (
                        <li
                          key={`carousel-indicator-${index}`}
                          data-slide-to={`${index}`}
                          className={index === activeIndex ? "active" : null}
                        ></li>
                      )
                  )}
                </ol>
                <a
                  onClick={() =>
                    activeIndex === sliderItems.length - 1
                      ? setActiveIndex(0)
                      : setActiveIndex(activeIndex + 1)
                  }
                  className="right carousel-control"
                  data-slide="next"
                >
                  <i className="fa fa-chevron-right"></i>
                </a>
              </div>
              {Array.isArray(attachedLinks) && attachedLinks.length > 0 && (
                <div className={styles.bottomLinksWrapper}>
                  {attachedLinks.map((item, key) => (
                    <div key={`${key}-bottom-links`}>
                      {item.external ? (
                        <a href={item.link} target="_blank">
                          <span>{item.title}</span>
                          <i
                            className={`fa fa-angle-left ${styles.angleForLinks}`}
                          ></i>
                        </a>
                      ) : (
                        <Link to={item.link}>
                          <span>{item.title}</span>
                          <i
                            className={`fa fa-angle-left ${styles.angleForLinks}`}
                          ></i>
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : isMobile && Array.isArray(sliderItems) && sliderItems.length > 0 ? (
        <div id="home-mobile-slider" className={styles.sliderMobile}>
          <HomeSlider
            slidesToShow={1}
            arrowsScroll={1}
            swipe={true}
            duration={200}
            centerMode={true}
            autoplay={false}
            dots={true}
            centerPadding={20}
            virtualList={true}
            dotsScroll={1}
            appendDots={(dots) => (
              <ul style={{ display: "block" }}>{dots.reverse()}</ul>
            )}
            prevArrow={
              <button className={styles.prevCarousel}>
                <i className="fa fa-angle-left"></i>
              </button>
            }
            nextArrow={
              <button className={styles.nextCarousel}>
                <i className="fa fa-angle-right"></i>
              </button>
            }
          >
            {sliderItems.map((item, index) => {
              return (
                <div
                  key={index + "-mobile-main-item"}
                  className={`${styles.carouselItem} carousel-item-wrapper`}
                >
                  <MobileSliderElem item={item} />
                </div>
              );
            })}
          </HomeSlider>
        </div>
      ) : (
        <></>
      )}
      {Array.isArray(attachedLinks) && attachedLinks.length > 0 && (
        <div className={styles.bottomLinksWrapper}>
          {attachedLinks.map((item, key) => (
            <div key={`${key}-bottom-links`}>
              {item.external ? (
                <a href={item.link} target="_blank">
                  <span>{item.title}</span>
                  <i className={`fa fa-angle-left ${styles.angleForLinks}`}></i>
                </a>
              ) : (
                <Link to={item.link}>
                  <span>{item.title}</span>
                  <i className={`fa fa-angle-left ${styles.angleForLinks}`}></i>
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const MobileSliderElem = ({ item }) => {
  return (
    <div className={styles.mobileSliderItems}>
      {item.attachment_files.map((el, key) =>
        key === 0 ? (
          <>
            <div className={styles.sliderImage}>
              <img src={el.server_relative_url} alt={item.title} />
            </div>
            {item.show_description && (
              <div className={styles.captions}>
                <div className={styles.title}>
                  <span>{item.title}</span>
                </div>
                {item &&
                  item.short_description &&
                  item.short_description.length > 0 && (
                    <div className={styles.content}>
                      {item.short_description}
                    </div>
                  )}
                {item.destination_url && (
                  <a
                    href={item.destination_url}
                    key={`el-key-slider-${item.title}-${key}`}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.loadMore}
                  >
                    ادامه مطلب <i className="fa fa-arrow-left" />
                  </a>
                )}
              </div>
            )}
          </>
        ) : null
      )}
    </div>
  );
};
const SliderElem = ({ item, activeIndex }) => {
  console.log("active inde", activeIndex);
  return (
    <div>
      <div
        className={styles.sliderContent}
        style={{ right: -(activeIndex * 100) + "vw" }}
      >
        {item.attachment_files.map((el, key) =>
          key === 0 ? (
            <div key={`slider-${key}`}>
              <div className={styles.sliderImage}>
                <img src={el.server_relative_url} alt={item.title} />
              </div>
              {item.show_description && (
                <div className={styles.captions}>
                  <div className={styles.title}>
                    <span>{item.title}</span>
                  </div>
                  {item &&
                    item.short_description &&
                    item.short_description.length > 0 && (
                      <div className={styles.content}>
                        {item.short_description}
                      </div>
                    )}
                  {item.destination_url && (
                    <a
                      href={item.destination_url}
                      key={`el-key-slider-${item.title}-${key}`}
                      target="_blank"
                      rel="noreferrer"
                      className={styles.loadMore}
                    >
                      ادامه مطلب <i className="fa fa-arrow-left" />
                    </a>
                  )}
                </div>
              )}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};
export default Slider;
